 <template>
  <div>
    <el-dialog
      title="售后服务"
      :visible="shouhouvisi"
      customClass="way aftersolt"
      :append-to-body="true"
      :before-close="shvisi"
    >
      <div class="content">
        <span>服务电话 ：186 5365 5380</span>
        <span>服务电话 ：177 6720 3459</span>
        <span>服务电话 ：139 1346 7848</span>
        <span>服务时间 工作日6 * 8小时</span><br />
        <div>
          <img src="../../assets/images/egpPic.jpg" alt="二维码" />
        </div>
        <p>
          &nbsp;&nbsp;山东亿盖普信息技术有限公司，是一家专注于研发企业管理平台系统领域的软件研发型技术公司。主要产品：供应商协同办公门户、条码扫描解决方案、生产过程追溯解决方案、地磅&amp;派车解决方案、企业软件定制化开发及系统集成（金蝶、用友、SAP、ORACLE)，拥有业界领先、完全自主知识产权的产品及技术体系。<br />设计理念：始终把用户的体验放在第一位，简单、实用、友好、高效。<br />服务理念：以客户为中心，全面满足客户需求。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shvisi()">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    shouhouvisi: { Type: Boolean },
  },
  data () {
    return {};
  },
  created () { },

  methods: {
    shvisi () {
      this.$emit("shvisi", false);
    },
  },
};
</script>
